<template>
  <div class="tile is-child box" :style="`background: url(${backgroundImage})`">
    <section :class="{ 'bg-blur': blur }">
      <div class="hero-body colored">
        <h1 v-if="title != ''" class="title is-4">{{ title }}</h1>
        <h2 v-if="subtitle != ''" class="title is-5">
          {{ subtitle }}
        </h2>
        <b-button
          @click="goToCTATarget"
          v-if="ctaText != ''"
          type="is-primary"
          >{{ ctaText }}</b-button
        >
        <slot> </slot>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'DashboardBannerTile',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    blur: {
      type: Boolean,
      default: true
    },
    ctaText: {
      type: String,
      default: ''
    },
    ctaTarget: {
      type: String,
      default: ''
    },
    backgroundImage: {
      type: String
    }
  },
  methods: {
    goToCTATarget() {
      if (this.ctaTarget == '') {
        return false
      }
      try {
        new URL(this.ctaTarget)
        window.open(this.ctaTarget, '_blank')
      } catch (_) {
        this.$router.push({ name: this.ctaTarget })
      }
    }
  }
}
</script>

<style scoped>
.bg-blur {
  background: #ffffff99;
  border-radius: 10px;
  backdrop-filter: blur(2px) brightness(1.1);
}
.tile.is-child {
  background-size: cover !important;
  margin: 10px !important;
}
.height-100 {
  height: 100%;
}
.image-background {
  position: relative;
  padding: 0;
  overflow: hidden;
}
.image-background img {
  position: absolute;
  width: 100%;
  height: 100%;
}

h1.title {
  color: #eb548b;
}
</style>
